export default {
	name: "order-enquiry-messages",
	props:{
		orderId: {
			default: null
		},
		companyId:{
			default: null
		},
		orderTypeId:{
			default: null
		},
		orderStatusId:{
			default: null
		}
	},
	data() {
		return {
			orderEnquiryMessages: [],
			company: {},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			newEnquiryMessage: {
				message: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isSaving: false
			},
			successModal:{
				modalHeading: "Success",
				modalMessage: null,
				elementId: "reviewOrderSuccessModal",
				showModal: false
			},
			loading: false,
			showMessageBox: false,
			pagingNumberTypingTimer: null,
			oldPageNumber: 1,
			orderStatus: null,
			orderType: null
		};
	},
	methods: {
		getOrderEnquiryMessagesByOrderId(){
			this.showMessageBox = false;
			this.loading = true;
			orderService.getOrderEnquiryMessagesByOrderId(this.orderId, this.pagingDetails.pageNumber, this.pagingDetails.pageSize).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderEnquiryMessages = successResponse.data.result;
						if(this.orderEnquiryMessages === null || this.orderEnquiryMessages.length === 0) {
							this.showMessageBox = true;
						}
						else{
							for(let i = 0; i < this.orderEnquiryMessages.length; i++) {
								this.orderEnquiryMessages[i].insertedOn = moment(this.orderEnquiryMessages[i].insertedOn, moment.ISO_8601).format("DD/MM/YYYY HH:mm");
							}
						}
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompany(){
			let request = {
				companyId: this.companyId
			};
			customerService.getCompany(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.company = successResponse.data.result;
					}
				},
				errorResponse => {
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		openReplyBox(){
			this.showMessageBox = true;
		},
		sendEnquiryMessage(){
			console.log("sendEnquiryMessage");
			if(this.newEnquiryMessage.message.value === null || this.newEnquiryMessage.message.value === ""){
				this.newEnquiryMessage.message.hasError = true;
				this.newEnquiryMessage.message.errorMessage = "Please enter a message";
				return;
			}
			this.newEnquiryMessage.message.hasError = false;
			this.newEnquiryMessage.message.errorMessage = null;
			this.loading = true;
			let request = {
				orderId: this.orderId,
				enquiryMessage: this.newEnquiryMessage.message.value,
				companyId: this.companyId
			};
			orderService.addOrUpdateOrderEnquiryMessage(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.successModal.modalMessage = "Message has been successfully sent";
						this.successModal.showModal = true;
						this.newEnquiryMessage.message.value = null;
						this.getOrderEnquiryMessagesByOrderId();
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onSuccessModalOkClick(){
			this.successModal.showModal = false;
		},
		nextPage(){
			if(this.pagingDetails.pageNumber !== this.pagingDetails.totalPages){
				this.pagingDetails.pageNumber++;
				this.oldPageNumber = this.pagingDetails.pageNumber;
				this.getOrderEnquiryMessagesByOrderId();
			}
		},
		previousPage(){
			if (this.pagingDetails.pageNumber > 1) {
				this.pagingDetails.pageNumber--;
				this.oldPageNumber = this.pagingDetails.pageNumber;
				this.getOrderEnquiryMessagesByOrderId();
			}
		},
		onPageNumberInput(){
			var self = this;
			console.log("newValue", this.pagingDetails.pageNumber);
			if(this.pagingDetails.pageNumber !== "" && this.pagingDetails.pageNumber !== null){
				var selectedPageNumber = parseInt(this.pagingDetails.pageNumber);
				if(selectedPageNumber <= 0){
					//this.canLoadDocuments = false;
					this.pagingDetails.pageNumber = this.oldPageNumber;
				}
				else if(selectedPageNumber > this.pagingDetails.totalPages){
					//this.canLoadDocuments = false;
					this.pagingDetails.pageNumber = this.oldPageNumber;
				}
				else{
					clearTimeout(self.pagingNumberTypingTimer);
					self.pagingNumberTypingTimer = setTimeout(function(){
						self.getOrderEnquiryMessagesByOrderId();
						clearTimeout(self.pagingNumberTypingTimer);
						self.pagingNumberTypingTimer = null;
						self.oldPageNumber = self.pagingDetails.pageNumber;
					}, 3000);
				}
			}
			// else{
			//     this.canLoadDocuments = false;
			//     this.pagingInfo.pageNumber = this.oldPageNumber;
			// }
		},
		onPageNumberBlur(){
			if(this.pagingDetails.pageNumber === null || this.pagingDetails.pageNumber === ""){
				this.pagingDetails.pageNumber = this.oldPageNumber;
			}
		},
		setBreadcrumbs() {
			var pageTitle = "Order Enquiry Messages - #" + this.orderId;
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		
	},
	watch:{
		companyId:{
			handler: function () {
				if (this.companyId !== null && this.companyId > 0) {
					this.getCompany();
				}
			},
			immediate: true,
			deep: true
		},
		orderId:{
			handler: function () {
				if (this.orderId !== null && this.orderId > 0) {
					this.getOrderEnquiryMessagesByOrderId();
					this.setBreadcrumbs();
				}
			},
			immediate: true,
			deep: true
		},
		orderTypeId:{
			handler: function () {
				if(this.orderTypeId !== null && this.orderTypeId > 0){
					switch (parseInt(this.orderTypeId)) {
						case orderHelper.orderType.exTank:
							this.orderType = "Ex-Tank";
							break;
						case orderHelper.orderType.collection:
							this.orderType = "Collection";
							break;
						case orderHelper.orderType.delivery:
							this.orderType = "Delivery";
							break;
						default:
							this.orderType = "Unknown";
							break;
					}
				}
			},
			immediate: true,
			deep: true
		},
		orderStatusId:{
			handler: function () {
				if(this.orderStatusId !== null && this.orderStatusId > 0){
					switch (parseInt(this.orderStatusId)) {
						case orderHelper.orderStatus.pending:
							this.orderStatus = "Pending";
							break;
						case orderHelper.orderStatus.accepted:
							this.orderStatus = "Accepted";
							break;
						case orderHelper.orderStatus.rejected:
							this.orderStatus = "Rejected";
							break;
						case orderHelper.orderStatus.complete:
							this.orderStatus = "Complete";
							break;
						case orderHelper.orderStatus.cancelled:
							this.orderStatus = "Cancelled";
							break;
						case orderHelper.orderStatus.readyForCollection:
							this.orderStatus = "Ready For Collection";
							break;
						case orderHelper.orderStatus.scheduledForDelivery:
							this.orderStatus = "Scheduled For Delivery";
							break;
						case orderHelper.orderStatus.onDelivery:
							this.orderStatus = "On Delivery";
							break;
						case orderHelper.orderStatus.readyForUpliftment:
							this.orderStatus = "Ready For Upliftment";
							break;
						case orderHelper.orderStatus.uplifted:
							this.orderStatus = "Uplifted";
							break;
						case orderHelper.orderStatus.scheduledDeliveryCancelled:
							this.orderStatus = "Scheduled Delivery Cancelled";
							break;
						default:
							this.orderStatus = "Unknown";
							break;
					}
				}
			},
			immediate: true,
			deep: true
		}
	}
};